// @flow
import { Draggable } from "@hello-pangea/dnd";
import React from "react";
import _ from "lodash";
import "../index.scss";
import { replaceUnderscoreWithSpace } from "./Utils";

const primaryButton = 0;
const keyCodes = {
  enter: 13,
  escape: 27,
  arrowDown: 40,
  arrowUp: 38,
  tab: 9,
};

const Task = ({
  task,
  index,
  entities,
  isSelected,
  isGhosting,
  droppableId,
  multiSelectTo,
  selectionCount,
  singleDragFlag,
  selectedTaskIds,
  toggleSelection,
  toggleSelectionInGroup,
}) => {

  const onKeyDown = (event, provided, snapshot) => {
    try {
      if (event.defaultPrevented) {
        return;
      }
      if (snapshot.isDragging) {
        return;
      }
      if (event.keyCode !== keyCodes.enter) {
        return;
      }
      // we are using the event for selection
      event.preventDefault();
      performAction(event);
    } catch(error) {
      console.log('something went wrong', error);
    }
    
  };

  const copySelectedTasksToClipboard = () => {
    // Get the selected tasks from the state or props

    // Create a new array to hold the copied tasks
    const copiedTasks = [];

    // Iterate over the selectedTaskIds and add the corresponding tasks to the copiedTasks array
    selectedTaskIds.forEach((taskId) => {
      const task = entities.tasks[taskId];
      copiedTasks.push(task);
    });

    // Convert the copiedTasks array to a JSON string and copy it to the clipboard
    const jsonString = JSON.stringify(copiedTasks);
    navigator.clipboard.writeText(jsonString);
  };
  // Using onClick as it will be correctly
  // preventing if there was a drag
  const onClick = (event) => {
    try {
      if (event.defaultPrevented) {
        return;
      }
      if (event.button !== primaryButton) {
        return;
      }
      event.preventDefault();
      performAction(event);
      if (event.shiftKey) {
        // Initiate copy operation if Shift key is pressed
        copySelectedTasksToClipboard();
      }
    } catch(error)  {
      console.log('something went wrong', error);
    }
    
  };

  const onTouchEnd = (event) => {
    try {
      if (event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      toggleSelectionInGroup(task.Field_Name);
      if (event.nativeEvent.shiftKey) {
        // Initiate copy operation if Shift key is pressed
        copySelectedTasksToClipboard();
      }
    } catch(error){
      console.log('something went wrong', error);
    }
    
  };

  // Determines if the platform specific toggle selection in group key was used
  const wasToggleInSelectionGroupKeyUsed = (event) => {
    const isUsingWindows = navigator.platform.indexOf("Win") >= 0;
    return isUsingWindows ? event.ctrlKey : event.metaKey;
  };

  // Determines if the multiSelect key was used
  const wasMultiSelectKeyUsed = (event) => event.shiftKey;

  const performAction = (event) => {
    try {
      if (wasToggleInSelectionGroupKeyUsed(event)) {
        toggleSelectionInGroup(task.Field_Name);
        return;
      }
      if (wasMultiSelectKeyUsed(event)) {
        multiSelectTo(task.Field_Name);
        return;
      }
      toggleSelection(task.Field_Name);
    } catch(error) {
      console.log('something went wrong', error);
    }
    
  };

  return (
    <Draggable draggableId={task?.Field_Name} index={index}>
      {(provided, snapshot) => {
        const shouldShowSelection = snapshot.isDragging && selectionCount > 1;

        return (
          <div
            onClick={onClick}
            ref={provided.innerRef}
            onTouchEnd={onTouchEnd}
            isSelected={isSelected}
            isGhosting={isGhosting}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            onKeyDown={(event) => onKeyDown(event, provided, snapshot)}
          >
            <div
              style={
                (isSelected && selectionCount > 0) || !singleDragFlag
                  ? {
                      backgroundColor: "#c2bdbd",
                      fontWeight: "900",
                      color: "#000",
                    }
                  : {}
              }
              className={`${
                entities.columns.availableFields.fieldsData &&
                entities.columns.availableFields.fieldsData.find(
                  (r, ind) =>
                    entities.columns.selectedFields.fieldsData.includes(r) && index === ind
                )
                  ? "test"
                  : ""
              }`}
            >
              {task?.Column_Name === "SelectAll" || task?.Field_Name === "SelectAll" ? (
                <span style={{ display: "none" }}></span>
              ) : (
                replaceUnderscoreWithSpace(task?.Column_Name) || replaceUnderscoreWithSpace(task?.Field_Name)
              )}
            </div>
            {shouldShowSelection ? (
              <div style={{ color: "red", fontWeight: "900" }}>{selectionCount}</div>
            ) : null}
          </div>
        );
      }}
    </Draggable>
  );
};
export default Task;